import {ReasonTypeInfoMap, ReasonTypeType, OrderSheetPageSet} from '@web/core/constants'
import {
    sendOrderApplyFailToNelo,
    sendOrderFailToNelo,
    sendOrderFailureToNelo,
    sendOrderInitToNelo,
    sendOrderTryToNelo,
    sendLeaveToNelo,
} from '@web/helpers/nelo'
import {actionLoggerCreator} from '@web/middlewares/logger'

import {MemberRootState as RootState} from '../../../interfaces'

const loggerMiddleware = actionLoggerCreator<RootState>({
    callbackLeaveAction: ({state, action, path, type}) => {
        sendLeaveToNelo({
            entry: state.common.entry,
            pageSet: OrderSheetPageSet.FAMILY_PAY,
            message: action.type,
            type,
            path,
        })
    },
    callbackLogAction: ({state, log}) => {
        if (log.type === 'failure') {
            const {code, message} = log.info
            sendOrderFailureToNelo({
                entry: state.common.entry,
                pageSet: OrderSheetPageSet.FAMILY_PAY,
                code,
                message,
            })
        } else if (log.type === 'info') {
            const {message} = log.info
            sendOrderInitToNelo({
                entry: state.common.entry,
                pageSet: OrderSheetPageSet.FAMILY_PAY,
                message,
            })
        } else if (log.type === 'orderTry') {
            const {code} = log.info
            sendOrderTryToNelo({
                entry: state.common.entry,
                code,
                pageSet: OrderSheetPageSet.FAMILY_PAY,
            })
        } else if (log.type === 'orderFail') {
            const {orderProcessId, orderNo, code, message} = log.info
            sendOrderFailToNelo({
                entry: state.common.entry,
                orderNo,
                orderProcessId,
                code,
                message,
                pageSet: OrderSheetPageSet.FAMILY_PAY,
                level: ReasonTypeInfoMap[code as ReasonTypeType]?.level ?? 'ERROR',
            })
        } else if (log.type === 'orderApplyFail') {
            const {code, message} = log.info
            sendOrderApplyFailToNelo({
                entry: state.common.entry,
                code,
                message,
                pageSet: OrderSheetPageSet.FAMILY_PAY,
                level: code ? (ReasonTypeInfoMap[code as ReasonTypeType]?.level ?? 'ERROR') : 'ERROR',
            })
        }
    },
})

export default loggerMiddleware
